module.exports = __webpack_public_path__ + "img/bg-image-13.c34e70c6.jpg";